module.exports = __webpack_public_path__ + "8d67924537f86dabe8f07a4bd2df1410.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/landing-page/landing-page.html
// module id = 1453
// module chunks = 0